import { createStyles, Theme } from '@material-ui/core/styles';

const style = (theme: Theme) => createStyles({

    fmTreeNode: {
        display: 'flex',
        alignItems: 'center',
        minHeight: 24,
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },

    selected: {
        backgroundColor: theme.palette.action.selected,
    },

});

export default style;
